import { render, staticRenderFns } from "./FinalEvaluationTreatments.vue?vue&type=template&id=635bce14&scoped=true&"
import script from "./FinalEvaluationTreatments.vue?vue&type=script&lang=js&"
export * from "./FinalEvaluationTreatments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bce14",
  null
  
)

export default component.exports